import React from "react";
import styled from "styled-components";
import { GridRow } from "../";
export const ProgressRing = ({
  progress = 0,
  size = "large",
  color = "purple"
}) => {
  const stroke = 2;
  const radius = size !== "small" ? 20 : 12;
  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - progress / 100 * circumference;
  return /*#__PURE__*/React.createElement(Wrapper, {
    width: radius * 2 - 8,
    height: radius * 2 - 8
  }, /*#__PURE__*/React.createElement(Container, {
    width: radius * 2,
    height: radius * 2
  }, size !== "small" && /*#__PURE__*/React.createElement(Percentage, {
    color: color
  }, Math.floor(progress), /*#__PURE__*/React.createElement(Sign, null, "%")), /*#__PURE__*/React.createElement("svg", {
    height: radius * 2,
    width: radius * 2,
    viewBox: `0 0 ${radius * 2} ${radius * 2}`
  }, /*#__PURE__*/React.createElement(SolidCircle, {
    id: `solidCircle${size}`,
    fill: "transparent",
    strokeWidth: stroke,
    r: normalizedRadius,
    cx: radius,
    cy: radius,
    color: color
  }), /*#__PURE__*/React.createElement(Circle, {
    id: `baseCircle${size}`,
    fill: "transparent",
    strokeWidth: stroke,
    r: normalizedRadius,
    cx: radius,
    cy: radius,
    circumference: circumference,
    offset: strokeDashoffset,
    color: color
  }))));
};
const Percentage = styled(GridRow)`
  justify-content: center;
  color: ${props => props.theme.palette[props.color].primary};
  position: absolute;
  width: 18px;
  height: 18px;
  z-index: 2;
  text-align: center;
  font-family: ${props => props.theme.fonts.workSans};
  font-size: 12px;
  line-height: 18px;
  font-weight: 600;
`;
const Sign = styled.div`
  font-family: ${props => props.theme.fonts.openSans};
  font-size: 8px;
  font-weight: 600;
`;
const Wrapper = styled.div`
  display: block;
  width: ${props => props.width}px;
  height: ${props => props.height}px;
`;
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  object-position: 50% 50%;
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  margin: -4px;
  position: relative;
`;
const Circle = styled.circle`
  stroke-dasharray: ${props => `${props.circumference} ${props.circumference}`};
  stroke-dashoffset: ${props => props.offset};
  transition: stroke-dashoffset 0.35s;
  transform: rotate(-90deg);
  transform-origin: center;
  stroke: ${props => props.theme.palette[props.color].primary};
`;
const SolidCircle = styled.circle`
  stroke: ${props => props.theme.palette[props.color].lightest};
  transform-origin: center;
`;